<template>
  <div class="greeting">
    <span class="greeting__message">{{ this.currentGreeting }}</span>
    <h2 class="greeting__username">
      <slot></slot>
    </h2>
  </div>
</template>

<script>
  import moment from 'moment/moment'

  const DEFAULT_UPDATE_TIMER = 1000 * 60 * 5 // timer for 5 minutes

  export default {
    name: 'Greeting',
    props: {
      morningGreeting: {
        type: Object,
        required: true,
        default: () => {
          return {
            key: 12,
            value: 'Good Morning'
          }
        }
      },
      afternoonGreeting: {
        type: Object,
        required: true,
        default: () => {
          return {
            key: 17,
            value: 'Good Afternoon'
          }
        }
      },
      eveningGreeting: {
        type: Object,
        required: true,
        default: () => {
          return {
            key: 24,
            value: 'Good Evening'
          }
        }
      }
    },
    data() {
      return {
        currentTime: +moment()
          .format('HH:mm')
          .split(':')[0],
        timerTimeout: null,
      }
    },
    mounted() {
      this.currentTime = +moment()
        .format('HH:mm')
        .split(':')[0]
      this.startTimer()
    },
    computed: {
      currentGreeting() {
        if (this.currentTime === null || this.currentTime === undefined) return 'Loading...'

        if (this.currentTime < this.morningGreeting.key) return this.morningGreeting.value
        if (this.currentTime < this.afternoonGreeting.key) return this.afternoonGreeting.value
        return this.eveningGreeting.value
      }
    },
    beforeDestroy() {
      clearTimeout(this.timerTimeout)
    },
    methods: {
      startTimer() {
        this.timerTimeout = setTimeout(() => {
          this.currentTime = +moment()
            .format('HH:mm')
            .split(':')[0]
          clearTimeout(this.timerTimeout)
          this.startTimer()
        }, DEFAULT_UPDATE_TIMER)
      },
    },
  }
</script>
